import React, { useEffect, useState } from 'react';
import { Modal, Card, Tabs, Descriptions, Alert, Form } from 'antd';
import {
    UserOutlined,
    MailOutlined,
    SafetyOutlined,
    WarningOutlined,
    ExclamationCircleFilled,
    HistoryOutlined
} from '@ant-design/icons';
import SideBar from '../../components/SideBar';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import axiosInstance from '../../variables/api/axiosInstance';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditUtilisateur from './detailsComponents/EditUtilisateur';
import SecuriteUtilisateur from './detailsComponents/SecuriteUtilisateur';
import SideBarDetailsUtilisateur from './detailsComponents/SideBarDetailsUtilisateur';
import ActiviteUtilisateur from './components/ActiviteUtilisateur';

const { confirm } = Modal;

const DetailsUtilisateur = () => {
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('account');
    const [modules, setModules] = useState([]);
    const [habilitations, setHabilitations] = useState([]);
    const [profils, setProfils] = useState([]);
    const [utilisateur, setUtilisateur] = useState({});

    const [form] = Form.useForm();

    const param = useParams();
    const navigate = useNavigate();

    //  Garde-fou "inactif"
    const isInactive = !!utilisateur && utilisateur.active === false;

    const requireActive = (actionLabel) => {
        if (isInactive) {
            toast.warn(`Impossible de ${actionLabel} : l'utilisateur est inactif. Activez-le d'abord.`);
            return true;
        }
        return false;
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (param.utilisateurId) {
                    const { data } = await axiosInstance.get(`/api/utilisateur/codeId/${param.utilisateurId}`);
                    setUtilisateur(data);
                }

                const [modulesRes, habilitationsRes, profilsRes] = await Promise.all([
                    axiosInstance.get(`/api/module`),
                    axiosInstance.get(`/api/habilitation`),
                    axiosInstance.get(`/api/profil/all`),
                ]);

                setModules(modulesRes.data);
                setHabilitations(habilitationsRes.data);
                setProfils(profilsRes.data);
            } catch (err) {
                console.error("Erreur lors de la récupération des données :", err);
            }
        };

        fetchData();
    }, [param.utilisateurId]);

    const cardStyle = {
        borderRadius: '16px',
        boxShadow: '0 2px 8px rgba(36, 33, 102, 0.08)',
        border: '1px solid #E6F0FF'
    };

    // const headerStyle = {
    //     backgroundColor: '#242166',
    //     color: 'white',
    //     borderRadius: '16px 16px 0 0',
    //     padding: '24px'
    // };

    const buttonStyle = {
        borderRadius: '8px',
        fontWeight: '600',
        height: '40px',
        fontSize: '14px'
    };

    const primaryButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#242166',
        borderColor: '#242166'
    };

    const dangerButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#DC2626',
        borderColor: '#DC2626',
        color: 'white'
    };

    // const warningButtonStyle = {
    //     ...buttonStyle,
    //     backgroundColor: '#F59E0B',
    //     borderColor: '#F59E0B'
    // };

    const infoButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#0EA5E9',
        borderColor: '#0EA5E9'
    };

    const successButtonStyle = {
        ...buttonStyle,
        backgroundColor: '#10B981',
        borderColor: '#10B981'
    };


    const showReinitialisationConfirm = (email) => {
        if (requireActive("réinitialiser le compte")) return;
        console.log("Email: ", email);
        confirm({
            title: "Etes-vous sûr de vouloir de réinitialiser ce compte utilisateur?",
            icon: <ExclamationCircleFilled />,
            content: "Cette action sera historisée et donc est irréversible",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                setLoading(true);
                reinitUtilisateur(email);
            },
            onCancel() {
                console.log("Cancel");
            },
            loading: loading
        });
    };

    const reinitUtilisateur = (email) => {
        if (isInactive) return;

        axiosInstance.get(`/api/utilisateur/reinitialisation/${email}`)
            .then((res) => {
                // console.log(res.data);
                navigate(`/details-utilisateur/${res.data.codeId}`, { replace: true });
                setLoading(false);
                toast(
                    "Utilisateur réinitialisé avec succès"
                );
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de la réinitialisation");
            });
    };


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"UTILISATEURS"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">

                            <div style={{
                                minHeight: '100vh',
                                backgroundColor: '#F7F9FB',
                                padding: '12px 30px'
                            }}>
                                <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
                                    {/* Header */}
                                    <div style={{ marginBottom: '24px' }}>
                                        <h1 style={{
                                            fontSize: '28px',
                                            fontWeight: '700',
                                            color: '#242166',
                                            marginBottom: '8px'
                                        }}>
                                            Détails de l'utilisateur
                                        </h1>
                                        <p style={{ color: '#6B7280', fontSize: '15px' }}>
                                            Gérez les informations et permissions de l'utilisateur
                                        </p>
                                    </div>

                                    {/* Alert si inactif */}
                                    {!utilisateur.active && (
                                        <Alert
                                            message="Utilisateur inactif"
                                            description="Cet utilisateur est inactif. Activez-le pour pouvoir modifier ses informations ou permissions."
                                            type="warning"
                                            showIcon
                                            icon={<WarningOutlined />}
                                            style={{
                                                marginBottom: '24px',
                                                borderRadius: '12px',
                                                border: '2px solid #FCD34D'
                                            }}
                                        />
                                    )}

                                    <div style={{ display: 'grid', gridTemplateColumns: '400px 1fr', gap: '24px' }}>
                                        {/* Sidebar - Profil Utilisateur */}
                                        <SideBarDetailsUtilisateur utilisateur={utilisateur} cardStyle={cardStyle} showReinitialisationConfirm={showReinitialisationConfirm} setEditModalOpen={setEditModalOpen} primaryButtonStyle={primaryButtonStyle} dangerButtonStyle={dangerButtonStyle} />

                                        {/* Main Content */}
                                        <Card style={cardStyle}>
                                            <Tabs
                                                activeKey={activeTab}
                                                onChange={setActiveTab}
                                                style={{ minHeight: '600px' }}
                                                items={[
                                                    {
                                                        key: 'account',
                                                        label: (
                                                            <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                                <UserOutlined style={{ marginRight: '8px' }} />
                                                                Compte
                                                            </span>
                                                        ),
                                                        children: (
                                                            <div style={{ padding: '24px' }}>
                                                                <div style={{
                                                                    backgroundColor: '#F7F9FB',
                                                                    borderRadius: '12px',
                                                                    padding: '32px',
                                                                    border: '2px solid #E6F0FF'
                                                                }}>
                                                                    <h3 style={{
                                                                        fontSize: '20px',
                                                                        fontWeight: '700',
                                                                        color: '#242166',
                                                                        marginBottom: '24px'
                                                                    }}>
                                                                        Informations du compte
                                                                    </h3>

                                                                    <Descriptions
                                                                        column={1}
                                                                        labelStyle={{
                                                                            fontWeight: '600',
                                                                            color: '#242166',
                                                                            fontSize: '14px',
                                                                            width: '200px'
                                                                        }}
                                                                        contentStyle={{
                                                                            color: '#2E2E2E',
                                                                            fontSize: '14px'
                                                                        }}
                                                                    >
                                                                        <Descriptions.Item label="Nom complet">
                                                                            {utilisateur?.personne?.prenom} {utilisateur?.personne?.nom}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Genre">
                                                                            {utilisateur?.personne?.genre === 'MASCULIN' ? 'Masculin' : 'Féminin'}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Email">
                                                                            {utilisateur?.email}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Téléphone">
                                                                            (+228) {utilisateur?.personne?.contact}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Fonction">
                                                                            {utilisateur?.personne?.fonction}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Adresse">
                                                                            {utilisateur?.personne?.adresse}
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Pays">
                                                                            Togo 🇹🇬
                                                                        </Descriptions.Item>
                                                                        <Descriptions.Item label="Langue">
                                                                            Français
                                                                        </Descriptions.Item>
                                                                    </Descriptions>
                                                                </div>

                                                                <div style={{
                                                                    backgroundColor: '#FEF3C7',
                                                                    borderRadius: '12px',
                                                                    padding: '20px',
                                                                    marginTop: '24px',
                                                                    border: '2px solid #FCD34D'
                                                                }}>
                                                                    <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                                                                        <WarningOutlined style={{ color: '#F59E0B', fontSize: '20px', marginTop: '2px' }} />
                                                                        <div>
                                                                            <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#92400E', marginBottom: '8px' }}>
                                                                                Zone de sécurité
                                                                            </h4>
                                                                            <p style={{ fontSize: '14px', color: '#78350F', margin: 0 }}>
                                                                                Les actions de modification, suspension ou réinitialisation sont irréversibles et seront historisées.
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        key: 'security',
                                                        label: (
                                                            <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                                <SafetyOutlined style={{ marginRight: '8px' }} />
                                                                Sécurité
                                                            </span>
                                                        ),
                                                        children: (
                                                            <SecuriteUtilisateur utilisateur={utilisateur} requireActive={requireActive} infoButtonStyle={infoButtonStyle} buttonStyle={buttonStyle} dangerButtonStyle={dangerButtonStyle} successButtonStyle={successButtonStyle} showReinitialisationConfirm={showReinitialisationConfirm} modules={modules} habilitations={habilitations} param={param} navigate={navigate} profils={profils} />
                                                        ),
                                                    },
                                                    {
                                                        key: 'notifications',
                                                        label: (
                                                            <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                                <MailOutlined style={{ marginRight: '8px' }} />
                                                                Notifications
                                                            </span>
                                                        ),
                                                        children: (
                                                            <div style={{ padding: '24px' }}>
                                                                <div style={{
                                                                    backgroundColor: '#F7F9FB',
                                                                    borderRadius: '12px',
                                                                    padding: '32px',
                                                                    border: '2px solid #E6F0FF'
                                                                }}>
                                                                    <h3 style={{
                                                                        fontSize: '20px',
                                                                        fontWeight: '700',
                                                                        color: '#242166',
                                                                        marginBottom: '24px'
                                                                    }}>
                                                                        Préférences de notifications
                                                                    </h3>
                                                                    <p style={{ color: '#6B7280', fontSize: '14px' }}>
                                                                        Gérer les notifications et alertes de l'utilisateur
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ),
                                                    },
                                                    {
                                                        key: 'activite',
                                                        label: (
                                                            <span style={{ fontSize: '15px', fontWeight: '600' }}>
                                                                <HistoryOutlined style={{ marginRight: '8px' }} />
                                                                Activité
                                                            </span>
                                                        ),
                                                        children: (
                                                            <ActiviteUtilisateur utilisateurCodeId={utilisateur?.codeId} />
                                                        ),
                                                    }
                                                ]}
                                            />
                                        </Card>
                                    </div>

                                    {/* Modal Édition */}
                                    <EditUtilisateur requireActive={requireActive} utilisateur={utilisateur} editModalOpen={editModalOpen} setEditModalOpen={setEditModalOpen} form={form} navigate={navigate} buttonStyle={buttonStyle} primaryButtonStyle={primaryButtonStyle} />
                                </div>
                            </div>
                        </div>

                        <Footer />
                    </div>
                </div>
            </div >
        </div >
    );
};

export default DetailsUtilisateur; 